import { useContext } from 'react';
import { OrgContext, type OrgContextValue } from './OrgContext';

export function useOrg(): OrgContextValue {
  const ctx = useContext(OrgContext);
  if (!ctx) {
    throw new Error('useOrg must be used within an OrgProvider');
  }
  return ctx;
}
